var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item"},[(_vm.icon)?_c('FontAwesomeIcon',{staticClass:"itemIcon",attrs:{"icon":_vm.icon}}):_vm._e(),_c('span',{staticClass:"itemName"},[_vm._v(_vm._s(_vm.itemName))]),_vm._v(" "),_c('span',{staticClass:"itemValue"},[_vm._v(_vm._s(_vm.itemValue))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }